import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import whatsapp from "../../images/whatsapp.png";

const Whatsapp = () => {
  return (
    <Box
      position={"fixed"}
      left={{ xs: "80%", sm: "95%" }}
      bottom={{ xs: "2%", sm: "5%" }}
    >
      <Link
        component="a"
        target={"_blank"}
        href="https://api.whatsapp.com/send?phone=233262536492"
      >
        <img src={whatsapp} alt={"whatsapp_logo"} width={"80%"} />
      </Link>
    </Box>
  );
};

export default Whatsapp;
